import "core-js/modules/es.array.push.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-76c0a00d"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "box-border text-sm font-medium h-14 bg-white flex justify-between items-center text-center border-b border-gray-200 flex-none px-2 md:pr-5"
};
const _hoisted_2 = {
  class: "flex h-full"
};
const _hoisted_3 = {
  class: "flex items-center font-normal"
};
const _hoisted_4 = {
  key: 0,
  class: "border-r .border-slate-200 mr-3"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "hidden md:inline-block"
}, "我的收藏", -1));
const _hoisted_6 = {
  key: 0,
  class: "hidden ml-2 md:block"
};
const _hoisted_7 = {
  key: 1,
  class: "hidden ml-2 md:block"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Expand = _resolveComponent("Expand");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_ai_dot = _resolveComponent("ai-dot");
  const _component_Star = _resolveComponent("Star");
  const _component_el_avatar = _resolveComponent("el-avatar");
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
  const _component_el_dropdown = _resolveComponent("el-dropdown");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_withDirectives(_createElementVNode("div", {
    onClick: _cache[0] || (_cache[0] = (...args) => _ctx.toggle && _ctx.toggle(...args)),
    class: "ml-2 mr-2 h-full border-b-2 border-transparent flex justify-center items-center cursor-pointer"
  }, [_createVNode(_component_el_icon, {
    size: "20"
  }, {
    default: _withCtx(() => [_createVNode(_component_Expand)]),
    _: 1
  })], 512), [[_vShow, !_ctx.showChatSlider]]), _createElementVNode("div", {
    class: _normalizeClass(["nav first", {
      active: _ctx.active === 'chat',
      'ml-60': _ctx.showChatSlider && _ctx.route.name !== 'chat' && !_ctx.isMobile
    }]),
    onClick: _cache[1] || (_cache[1] = (...args) => _ctx.goChat && _ctx.goChat(...args))
  }, " AI聊天 ", 2), _createElementVNode("div", {
    class: _normalizeClass(["nav relative", {
      active: _ctx.active === 'canvas'
    }]),
    onClick: _cache[2] || (_cache[2] = $event => _ctx.router.push({
      name: 'canvas'
    }))
  }, [_createTextVNode(" AI绘画 "), _createVNode(_component_ai_dot, {
    target: "canvas",
    style: {
      "top": "0.25rem"
    }
  })], 2), _createElementVNode("div", {
    class: _normalizeClass(["nav relative", {
      active: _ctx.active === 'square'
    }]),
    onClick: _cache[3] || (_cache[3] = $event => _ctx.router.push({
      name: 'square'
    }))
  }, [_createTextVNode(" AI广场 "), _createVNode(_component_ai_dot, {
    target: "square",
    style: {
      "top": "0.25rem"
    }
  })], 2), _createElementVNode("div", {
    class: _normalizeClass(["nav relative", {
      active: _ctx.active === 'invite'
    }]),
    onClick: _cache[4] || (_cache[4] = $event => _ctx.router.push({
      name: 'invite'
    }))
  }, [_createTextVNode(" 分享领现金红包！ "), _createVNode(_component_ai_dot, {
    target: "invite",
    style: {
      "top": "0.25rem"
    }
  })], 2)]), _createElementVNode("div", _hoisted_3, [_ctx.route.name !== 'chat' ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("div", {
    onClick: _cache[5] || (_cache[5] = (...args) => _ctx.goCollect && _ctx.goCollect(...args)),
    class: "py-1 px-2 text-center cursor-pointer mr-3 flex justify-center items-center ml-3 text-xs font-medium text-indigo-600 dark:text-indigo-400 bg-indigo-400/10 rounded-full hover:bg-indigo-400/20"
  }, [_hoisted_5, _createVNode(_component_el_icon, {
    size: "13",
    class: "ml-0.5"
  }, {
    default: _withCtx(() => [_createVNode(_component_Star)]),
    _: 1
  })])])) : _createCommentVNode("", true), _createVNode(_component_el_dropdown, {
    onCommand: _ctx.handleCommand,
    trigger: "click",
    "popper-class": "bg-black"
  }, _createSlots({
    default: _withCtx(() => [_createElementVNode("div", {
      class: "flex items-center",
      onClick: _cache[6] || (_cache[6] = (...args) => _ctx.login && _ctx.login(...args))
    }, [_createVNode(_component_el_avatar, {
      size: 38,
      src: _ctx.userInfo.avatar || require('@/assets/no_avatar.png')
    }, null, 8, ["src"]), _ctx.isLogin ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.userInfo.nickname), 1)) : (_openBlock(), _createElementBlock("span", _hoisted_7, "点此登录"))])]),
    _: 2
  }, [_ctx.isLogin ? {
    name: "dropdown",
    fn: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
      default: _withCtx(() => [_createVNode(_component_el_dropdown_item, {
        command: "userInfo"
      }, {
        default: _withCtx(() => [_createTextVNode("个人中心")]),
        _: 1
      }), _createVNode(_component_el_dropdown_item, {
        command: "upgrade"
      }, {
        default: _withCtx(() => [_createTextVNode("升级会员")]),
        _: 1
      }), _createVNode(_component_el_dropdown_item, {
        command: "logout"
      }, {
        default: _withCtx(() => [_createTextVNode("退出登录")]),
        _: 1
      })]),
      _: 1
    })]),
    key: "0"
  } : undefined]), 1032, ["onCommand"])])]);
}